'use client'

import * as React from 'react'
import { ReactElement, SVGProps } from 'react'

export function SvgTripfavo(_props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      className="stroke-mykonos stroke-[4]"
      width="32"
      height="32"
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.07501 3H35L34.9824 3.05011C33.6268 6.9146 31.4638 12.964 29.3801 18.5527C27.2969 24.1403 25.2919 29.2704 24.253 31.2942C23.2098 33.3264 21.5938 34.3227 19.9993 34.7421C18.4058 35.1612 16.8327 35.0046 15.8696 34.7307L15.8688 34.7305L15.868 34.7303C13.7529 34.0129 12.525 32.4431 11.85 30.7746C11.1755 29.1071 11.0523 27.3395 11.1462 26.2198L11.1464 26.217L12.9597 18.3814C6.02622 18.1289 3.625 14.3083 3.29415 12.4085C2.53466 9.15748 3.33768 6.9091 4.6543 5.42136C5.96919 3.93558 7.79307 3.21191 9.07233 3.00044L9.07501 3ZM9.08045 3.07431C7.81238 3.28452 6.00603 4.00257 4.70544 5.4722C3.4058 6.94075 2.60794 9.16325 3.36246 12.3918L3.36272 12.3929L3.36291 12.394C3.68651 14.2559 6.06282 18.0713 13.0052 18.3087L13.0484 18.3102L11.2158 26.2292C11.1232 27.339 11.2458 29.0923 11.9145 30.7453C12.5833 32.3985 13.7975 33.9497 15.8886 34.6592C16.8421 34.9302 18.4026 35.0855 19.9824 34.6699C21.5617 34.2545 23.1593 33.2691 24.1914 31.2587C25.2278 29.2398 27.2311 24.1146 29.3149 18.5254C31.3893 12.9614 33.5426 6.94051 34.8991 3.07431H9.08045Z"
      />
    </svg>
  )
}
